import React from "react";
import { Row, Col, Container } from "reactstrap";
import { Constants } from "../../Constants";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col style={{ textAlign: 'center' }}>
                            {new Date().getFullYear()} © by <a href="http://sayasoftware.com" target="_blank">SayaSoftware</a>. Versión {Constants.VERSION}
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
